// extracted by mini-css-extract-plugin
module.exports = {"light":"App_light__y10vQ","dark":"App_dark__2PeEo","container":"App_container__1ZCcP","topbarContainer":"App_topbarContainer__zf2KX"};